import React          from 'react';
import OurTeamPreview from 'pursuit/components/Widgets/OurTeamPreview';
import staff          from 'pursuit/config/staff';

export default function OurTeamFront() {
    return (
        <section role="main" className="our-team">
            <h2 className="content-title justify-center minor-margin--bottom">Our Team</h2>

            <div className="grid-center">
                <div className="col-11_xs-11_md-9 section-title text-large highlight">
                    Service Providers
                </div>
            </div>

            <div className="grid-center">
                <div className="col-11_xs-11_md-9">
                    <div className="grid">
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['adrienne-mcconnell']} />
                        </div>
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['naomi-ha']} />
                        </div>
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['emily-younes']} />
                        </div>
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['kate-fewer']} />
                        </div>
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['lauren-miller']} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid-center">
                <div className="col-11_xs-11_md-9 section-title text-large highlight">
                    Instructors
                </div>
            </div>

            <div className="grid-center">
                <div className="col-11_xs-11_md-9">
                    <div className="grid">
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['robin-hurlow']} />
                        </div>
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['neesa-kenemy']} />
                        </div>
                        <div className="col-4_xs-12 justify-center">
                            <OurTeamPreview staffer={staff['dana-bondy']} />
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
};
